module.exports = __webpack_public_path__ + "img/Weapon_62.7c36733c.png";